import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
export default function CustomLink({link, className, text}) {
    const {t} = useTranslation();
    return <Link to={link} className={className}>{t(text)}</Link>;
}